import { apiSlice } from "app/api/apiSlice"


export const companyRolesApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['Roles'],
    endpoints: builder => ({
        getCompanyRoles: builder.query({
            query: () => '/company/roles',
            keepUnusedDataFor: 5,
            providesTags: ['Roles']
        }),
        // PUT Employee New Status
        editRole: builder.mutation({
            query: (
                role
            ) => ({
                url: 'company/roles',
                method: 'PUT',
                body: role
            }),
            invalidatesTags: ['Roles']
        }),
        updateRolePermissions: builder.mutation({
            query: ({ guid, permissions, isCritical }) => ({
                url: `/company/roles/permissions`,
                method: "PUT",
                body: { permissions, isCritical, guid },
            }),
            invalidatesTags: ["Roles"]
        })
    })
})

export const {
    useGetCompanyRolesQuery,
    useEditRoleMutation,
    useUpdateRolePermissionsMutation
} = companyRolesApiSlice 